// Pagination.js
import React from 'react';
import './Pagination.css';

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const getVisiblePages = () => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, index) => index + 1);
        }

        const pages = [1];
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);

        if (start > 2) pages.push('start-ellipsis');
        for (let page = start; page <= end; page += 1) {
            pages.push(page);
        }
        if (end < totalPages - 1) pages.push('end-ellipsis');

        pages.push(totalPages);
        return pages;
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            onPageChange(pageNumber);
        }
    };

    if (totalPages <= 1) {
        return null;
    }

    return (
        <nav className="pagination" aria-label="Pagination">
            <button 
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1}
                className="pagination-nav"
            >
                Previous
            </button>
            
            {getVisiblePages().map((page) => (
                typeof page === 'number' ? (
                    <button
                        key={page}
                        className={currentPage === page ? 'active' : ''}
                        onClick={() => handlePageChange(page)}
                        aria-current={currentPage === page ? 'page' : undefined}
                    >
                        {page}
                    </button>
                ) : (
                    <span key={page} className="pagination-ellipsis">...</span>
                )
            ))}

            <button 
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
                className="pagination-nav"
            >
                Next
            </button>
        </nav>
    );
};

export default Pagination;
